import { ID } from "common/entities/IEntity";

export interface IArticleParams {
	id?: ID;
	ids?: ID[];
	itemId?: ID;
	itemIds?: ID[];
	itemExternalId?: string;
	itemExternalIds?: string[];
	query?: string;
	pageSize?: number;
	pageNumber?: number;
	sort?: string;
	tagIds?: ID[];
	tagOrCondition?: boolean;
	displayRangeStart?: Date;
	displayRangeEnd?: Date;
	catalogIds?: ID[];
	language?: string;
	itemTypeIds?: ID[];
	notIncludeItemTypeIds?: ID[];
	bundleTagIds?: ID[];
	sortByModifyDays?: number;
	institution?: string;
	categoryIds?: ID[];
	knowledgeBaseGuid?:string;
	knowledgeBaseExternalId?:string;

}

export const articleParamNames = [
	"id",
	"ids",
	"itemId",
	"itemIds",
	"itemExternalIds",
	"query",
	"tagIds",
	"tagOrCondition",
	"requiredTagIds",
	"displayRangeStart",
	"displayRangeEnd",
	"catalogIds",
	"language",
	"pageSize",
	"sort",
	"pageNumber",
	"itemTypeIds",
	"notIncludeItemTypeIds",
	"bundleTagIds",
	"sortByModifyDays",
	"institution",
	"isLoadMore",
	"knowledgeBaseGuid",
	"knowledgeBaseExternalId"
];



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/entities/ArticleParams.ts